import { render } from "./BottomNavigation.vue?vue&type=template&id=5b6e9106&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=5b6e9106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6e9106"]])

export default __exports__